import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import customersReducer from './slices/customersSlice';
import transactionsReducer from './slices/transactionsSlice';
import mosadsReducer from './slices/mosadsSlice';
import banksReducer from './slices/banksSlice';
import employeesReducer from './slices/employeesSlice';
import userReducer from './slices/userSlice';
import { loadUserInitialState } from './slices/userSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user', 'mosads', 'customers', 'banks'] // only persist the auth slice
};

const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  customers: customersReducer,
  transactions: transactionsReducer,
  mosads: mosadsReducer,
  banks: banksReducer,
  employees: employeesReducer,
  user: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  preloadedState: {
    user: loadUserInitialState(),
  },
});

export const persistor = persistStore(store);
export default store; 